<div class="main-content table-page table-page--compact table-page--dense tarea-consulta-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Tarea diaria</h1>
      </div>
      <div class="table-page__toolbar-actions">
        <button
          *ngIf="resumenJornada?.permiteSolicitud"
          type="button"
          mat-raised-button
          class="btn table-page__primary-btn tarea-consulta-page__btn--warning"
          (click)="solicitarAutorizacionTiempoExtra()"
        >
          <span class="material-icons">send</span>
          Solicitar autorización
        </button>
        <button
          type="button"
          mat-raised-button
          class="btn table-page__primary-btn"
          (click)="registraTarea()"
        >
          <span class="material-icons">add_circle</span>
          Agregar tarea
        </button>
        <button
          type="button"
          mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary"
          (click)="irAAutorizaciones()"
        >
          <span class="material-icons">rule</span>
          Autorizaciones
        </button>
        <button
          type="button"
          mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary"
          (click)="abrirCapturaManual()"
        >
          <span class="material-icons">edit_calendar</span>
          Captura manual semanal
        </button>
        <button
          type="button"
          mat-raised-button
          class="btn table-page__icon-btn table-page__icon-btn--secondary"
          (click)="irABitacoras()"
        >
          <span class="material-icons">visibility</span>
          Ver historial
        </button>
      </div>
    </section>

    <section class="tarea-consulta-page__summary-grid">
      <article class="tarea-consulta-page__summary-card">
        <span class="tarea-consulta-page__eyebrow">Tiempo total hoy</span>
        <div class="tarea-consulta-page__summary-main">
          <strong *ngIf="!activo">{{ tiempoTotal }}</strong>
          <app-cronometro *ngIf="activo" [useValue]="usuarioCronometro"></app-cronometro>
        </div>
      </article>

      <article class="tarea-consulta-page__summary-card">
        <span class="tarea-consulta-page__eyebrow">Tarea activa</span>
        <div class="tarea-consulta-page__summary-main tarea-consulta-page__summary-main--stack">
          <strong>{{ nombreTareaActiva || "Sin tarea activa" }}</strong>
          <app-cronometro *ngIf="activo" [useValue]="tareaCronometro"></app-cronometro>
          <small *ngIf="!activo">Sin sesión en curso</small>
        </div>
      </article>

      <article class="tarea-consulta-page__summary-card">
        <span class="tarea-consulta-page__eyebrow">Jornada de hoy</span>
        <div class="tarea-consulta-page__summary-main tarea-consulta-page__summary-main--stack">
          <strong>{{ horaEntradaTexto }} - {{ horaSalidaTexto }}</strong>
          <small>{{ bloquesComidaTexto }}</small>
        </div>
      </article>

      <article class="tarea-consulta-page__summary-card">
        <span class="tarea-consulta-page__eyebrow">Reloj local</span>
        <div class="tarea-consulta-page__summary-main">
          <app-reloj></app-reloj>
        </div>
      </article>
    </section>

  <div class="row tarea-consulta-page__content-row">
    <div class="col-12 col-xl-7">
      <section class="table-page__card tarea-consulta-page__panel">
        <div class="table-page__toolbar tarea-consulta-page__panel-head">
          <div class="table-page__copy">
            <h2>Tareas de hoy</h2>
          </div>
        </div>

        <div class="table-page__table-wrap" *ngIf="listaTareasDiarias?.length; else emptyTareasHoy">
          <table class="table-page__table tarea-consulta-page__table tarea-consulta-page__table--today">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tiempo hoy</th>
                <th>Acumulado</th>
                <th>Estatus</th>
                <th class="table-page__actions-head">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let row of listaTareasDiarias
                    | paginate
                      : {
                          id: 'tareasHoy',
                          itemsPerPage: pageSize,
                          currentPage: currentPageTareasHoy,
                          totalItems: totalRegistrosTareasHoy
                        }
                "
              >
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__name">{{ row.nombre }}</span>
                    <span class="table-page__subtext">
                      {{ row.descripcion || "Sin descripción" }}
                    </span>
                  </div>
                </td>
                <td><span class="table-page__text">{{ row.tiempoTotalInvertidoXDiaStr }}</span></td>
                <td><span class="table-page__text">{{ row.tiempoTotalInvertidoStr }}</span></td>
                <td>
                  <span
                    class="table-page__status-badge"
                    [ngClass]="{
                      'is-active': row.estatus === 'ACTIVO',
                      'is-pending': row.estatus === 'PAUSADO',
                      'is-inactive': row.estatus === 'CREADO',
                      'is-danger': row.estatus === 'TERMINADO'
                    }"
                  >
                    {{ row.estatus }}
                  </span>
                </td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button
                      type="button"
                      class="table-page__action-btn"
                      matTooltip="Pausar"
                      aria-label="Pausar"
                      [hidden]="row.estatus === 'TERMINADO' || row.estatus === 'PAUSADO'"
                      (click)="actualizaEstatus(row, 'PAUSADO')"
                    >
                      <span class="material-icons">pause</span>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn"
                      matTooltip="Reanudar"
                      aria-label="Reanudar"
                      [hidden]="row.estatus === 'TERMINADO' || row.estatus === 'ACTIVO'"
                      (click)="actualizaEstatus(row, 'ACTIVO')"
                    >
                      <span class="material-icons">play_arrow</span>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn"
                      [hidden]="row.estatus === 'TERMINADO'"
                      matTooltip="Terminar"
                      aria-label="Terminar"
                      (click)="actualizaEstatus(row, 'TERMINADO')"
                    >
                      <span class="material-icons">done</span>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-page__footer" *ngIf="showPaginationTareasHoy">
          <div class="table-page__meta">
            Mostrando {{ (currentPageTareasHoy - 1) * pageSize + 1 }} a
            {{ (currentPageTareasHoy - 1) * pageSize + (listaTareasDiarias?.length || 0) }} de
            {{ totalRegistrosTareasHoy }}
          </div>
          <div class="table-page__pager table-page__pager--ngx">
            <pagination-controls
              [id]="'tareasHoy'"
              responsive="true"
              class="my-pagination"
              [directionLinks]="true"
              [autoHide]="false"
              [previousLabel]="labels.previousLabel"
              [nextLabel]="labels.nextLabel"
              [maxSize]="5"
              (pageChange)="consultaPaginaTareasHoy($event)"
            ></pagination-controls>
          </div>
        </div>
      </section>
    </div>

    <div class="col-12 col-xl-5">
      <section class="table-page__card tarea-consulta-page__panel">
        <div class="table-page__toolbar tarea-consulta-page__panel-head">
          <div class="table-page__copy">
            <h2>Mis tareas</h2>
          </div>
        </div>

        <div class="table-page__table-wrap" *ngIf="listaTareas?.length; else emptyMisTareas">
          <table class="table-page__table tarea-consulta-page__table tarea-consulta-page__table--mine">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Registro</th>
                <th class="table-page__actions-head">Detalle</th>
                <th class="table-page__actions-head">Iniciar hoy</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let row of listaTareas
                    | paginate
                      : {
                          id: 'misTareas',
                          itemsPerPage: pageSize,
                          currentPage: currentPageMisTareas,
                          totalItems: totalRegistrosMisTareas
                        }
                "
              >
                <td>
                  <div class="table-page__cell-stack">
                    <span class="table-page__name">{{ row.nombre }}</span>
                    <span class="table-page__subtext">{{ row.estatus }}</span>
                  </div>
                </td>
                <td><span class="table-page__text">{{ row.fecha_creacion | date : "dd/MM/yyyy" }}</span></td>
                <td class="table-page__actions table-page__actions--multi">
                  <div class="table-page__action-group">
                    <button
                      type="button"
                      class="table-page__action-btn"
                      matTooltip="Ver detalle"
                      aria-label="Ver detalle"
                      (click)="verDetalle(row)"
                    >
                      <span class="material-icons">description</span>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn table-page__action-btn--danger"
                      [hidden]="row.estatus !== 'CREADO'"
                      matTooltip="Eliminar"
                      aria-label="Eliminar"
                      (click)="eliminarTarea(row)"
                    >
                      <span class="material-icons">delete_forever</span>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn"
                      [hidden]="row.estatus === 'TERMINADO' || row.estatus === 'CREADO'"
                      matTooltip="Terminar"
                      aria-label="Terminar"
                      (click)="actualizaEstatus(row, 'TERMINADO')"
                    >
                      <span class="material-icons">done</span>
                    </button>
                  </div>
                </td>
                <td class="table-page__actions">
                  <div class="table-page__action-group">
                    <button
                      type="button"
                      class="table-page__action-btn tarea-consulta-page__start-btn"
                      matTooltip="Iniciar"
                      aria-label="Iniciar"
                      [hidden]="row.estatus === 'TERMINADO'"
                      [disabled]="row.band || !!row.tiempoTotalInvertidoXDiaStr"
                      (click)="establecerTiempoActividad(row)"
                    >
                      <span class="material-icons">play_circle</span>
                      Iniciar
                    </button>
                    <span
                      *ngIf="row.estatus === 'TERMINADO'"
                      class="table-page__status-badge is-active"
                    >
                      TERMINADO
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="table-page__footer" *ngIf="showPaginationMisTareas">
          <div class="table-page__meta">
            Mostrando {{ (currentPageMisTareas - 1) * pageSize + 1 }} a
            {{ (currentPageMisTareas - 1) * pageSize + (listaTareas?.length || 0) }} de
            {{ totalRegistrosMisTareas }}
          </div>
          <div class="table-page__pager table-page__pager--ngx">
            <pagination-controls
              [id]="'misTareas'"
              responsive="true"
              class="my-pagination"
              [directionLinks]="true"
              [autoHide]="false"
              [previousLabel]="labels.previousLabel"
              [nextLabel]="labels.nextLabel"
              [maxSize]="5"
              (pageChange)="consultaPaginaMisTareas($event)"
            ></pagination-controls>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
</div>

<ng-template #emptyTareasHoy>
  <div class="table-page__empty">
    <span class="material-icons">event_busy</span>
    <h3>No tienes tareas activas o pausadas para hoy.</h3>
  </div>
</ng-template>

<ng-template #emptyMisTareas>
  <div class="table-page__empty">
    <span class="material-icons">playlist_add_check</span>
    <h3>Todavía no tienes tareas registradas.</h3>
  </div>
</ng-template>
